import { IoPersonOutline, IoCashOutline, IoPricetagOutline, IoNotificationsOutline } from "react-icons/io5";
import { RiUserLine } from "react-icons/ri";
import { TbBell } from "react-icons/tb";
import { HiOutlineCreditCard } from "react-icons/hi2";
import { TbPlugConnected } from "react-icons/tb";

interface MenuItem {
  icon: React.ElementType;
  label: string;
  path: string;
}

export const settingMenuItems: MenuItem[] = [
    {
        icon: IoPersonOutline,
        label: 'Profile',
        path: '/settings/profile'
    },
    { 
        icon: IoPricetagOutline,
        label: 'Plan', 
        path: '/settings/plan' 
    },
    { 
        icon: IoCashOutline,
        label: 'Billing', 
        path: '/settings/billing' 
    },
    { 
        icon: IoNotificationsOutline,
        label: 'Notifications', 
        path: '/settings/notifications' 
    },
    {
        label: 'Integrations',
        path: '/settings/integrations',
        icon: TbPlugConnected
    },
]; 